<template>
  <div class="bx-header__channel-navi bx-typo--header-channel-navi">
    <a v-for="channel in menuItems"
       :key="channel.index"
       :href="channel.url"
       :target="channel.target">
      <svg role="img"
           :data-channel-name="channelMenuStyleMap[channel.name.toLowerCase()]">
        <use :href="`/images/bravo/bravo_logo_sprite.svg#logo_${channelMenuStyleMap[channel.name.toLowerCase()]}`" />
      </svg>
    </a>
  </div>
</template>

<script>
import { mapState } from 'pinia'

import { usePageStore } from '../../../stores/page'

export default {
  props: {
    menuChannels: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      channelMenuStyleMap: {
        bravo: 'bravo',
        'dr. sommer': 'dr-sommer',
        'bravo girl!': 'bravo-girl',
        'bravo sport': 'bravo-sport',
        'girl!': 'bravo-girl',
        sport: 'bravo-sport'
      }
    }
  },
  computed: {
    ...mapState(usePageStore, ['pageData']),
    menuItems () {
      const channels = [{
        name: 'Bravo',
        target: '_self',
        url: '/'
      }, ...JSON.parse(JSON.stringify(this.menuChannels))]
      return channels.filter(channel => {
        return this.activeStyle.toLowerCase() !== this.channelMenuStyleMap[channel.name.toLowerCase()]
      })
    },
    activeStyle () {
      return this.pageData.pageMeta.style || 'bravo'
    }
  }
}
</script>
